import { useEffect, useState } from 'react';
import userAction from '../actions/userAction';
import { useAuthDispatchContext } from '../../auth/context/authContext';
import storage from '/src/utils/storage';
import { useNavigate} from 'react-router-dom';
function updateUser({children, permissions}) {
    const [isLoaded, setIsLoaded] = useState(false);

    const navigate = useNavigate();
    // Disable the return to enable resfh user each time you change page

    const dispatch = useAuthDispatchContext();
    useEffect( () => {
        var isUserInfo = true;
        const fetchData = async () => {

            const data = await userAction.refreshUserInformation();
            
            if(!isUserInfo) return;

            if (!data) {
               
                storage('local').remove('user');
                storage('local').remove('token');
                storage('local').remove('refresh_token');
                dispatch({type : 'loginOut'});
                navigate('/login');
                return;
            };

            const { user, company, permissions } = data;
            storage('local').set('user', user);
            storage('session').set('company', company);
            storage('session').set('permissions', permissions);
            dispatch({type : 'refreshUserInfo', payload : { user, token : storage('local').get('token')} });
            setIsLoaded(true);
        }

        fetchData().catch((err) => console.error(err));

        return () => isUserInfo = false;
    }, [dispatch]);
    
    if(!isLoaded) {
        return <></>;
    }
    if(permissions.length > 0 && !permissions.some(perm => storage('session').get('permissions').includes(perm))) {
        navigate('/404');
    }
    return children;
}

export default updateUser;